import React, { useState } from "react";
import { Button } from "@hopper/button";

import { Test } from "types/graphql";
import { PublishAllResultsModal } from "./publish_all_results_modal";
import { Participant } from "components/flexible_testing/shared/chat";
import { SelectionRequirementsGroup } from "components/flexible_testing/shared/use_selection_requirements_groups";

type PublishAllResultsButtonProps = {
  selectionRequirementsGroups: SelectionRequirementsGroup[];
  testId: Test["id"];
};

export const PublishAllResultsButton = ({ selectionRequirementsGroups, testId }: PublishAllResultsButtonProps) => {
  const [showModal, setShowModal] = useState(false);
  const participantIds = selectionRequirementsGroups.reduce(
    (participants: Participant["id"][], group) =>
      participants.concat(
        group.participants
          .filter(
            participant =>
              participant.status === "results_approved" && participant.numberOfPendingIssueModerations === 0,
          )
          .map(participant => participant.id),
      ),
    [],
  );

  return (
    <>
      <Button
        className="m-xs"
        variant="primary"
        appearance="default"
        onClick={() => setShowModal(true)}
        disabled={participantIds.length === 0}
      >
        Publish all
      </Button>
      <PublishAllResultsModal
        participantIds={participantIds}
        testId={testId}
        isOpen={showModal}
        onClose={() => setShowModal(false)}
      />
    </>
  );
};
